import { render, staticRenderFns } from "./FaceAuthorize.vue?vue&type=template&id=1a1c5ce2&scoped=true&"
import script from "./FaceAuthorize.vue?vue&type=script&lang=js&"
export * from "./FaceAuthorize.vue?vue&type=script&lang=js&"
import style0 from "./FaceAuthorize.vue?vue&type=style&index=0&id=1a1c5ce2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1c5ce2",
  null
  
)

export default component.exports